import React from 'react';
import  ClassAssembly12A2026  from 'views/ClassAssembly12A2026';



const ClassAssemblyPage = () => {
    return <ClassAssembly12A2026/>;
  };
  
  export default ClassAssemblyPage;